// A supprimer quandil y aura d'autres liens
// eslint-disable-next-line import/prefer-default-export
export const LIEN_BOUTON_AVIS_AJOUT_ARME_MANQUANTE =
    'https://voxusagers.numerique.gouv.fr/Demarches/1282?&view-mode=formulaire-avis&nd_mode=en-ligne-enti%C3%A8rement&nd_source=button&key=dbe649786212a855ffc4a74b3ce0abb4';
